<template>
  <span :class="colorClass">
    {{ capitalize(params.value || '') }}
  </span>
</template>

<script setup>
import { computed } from 'vue'
import capitalize from '../../../Filters/Capitalize'

/**
 * @typedef {Object} StatusCellParams
 * @param {String} value
 */
const props = defineProps({
  /** @type {StatusCellParams} */
  params: {
    type: Object,
    required: true
  }
})

const colorClass = computed(() => {
  if (props.params.validStatuses?.includes(props.params.value)) {
    return 'text-green-400'
  }
  if (props.params.invalidStatuses?.includes(props.params.value)) {
    return 'text-red-400'
  }
  if (props.params.disabledStatuses?.includes(props.params.value)) {
    return 'text-gray-400'
  }
  return ''
})
</script>
